import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'hover-role-renderer',
  templateUrl: './hover-role-renderer.component.html',
  styleUrls: ['./hover-role-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HoverRoleRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParams;   
    public roles : any = [];
    public details : string;    
    show = false;
    
    
    constructor() {
  
    }
  
    initilize(params: ICellRendererParams) {
      if (params && params.data) {
        this.details = params.data.user_role.toString();
        this.roles = params.data.User_Roles;
      }   
    }

      
    // called on init
    agInit(params: any): void {
      this.initilize(params);
    }
  
    // called when the cell is refreshed
    refresh(params: any): boolean {
      this.initilize(params);
      return true;
    }
   
}